import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedureCharge from './patient-procedure-charge';
import PatientProcedureChargeDetail from './patient-procedure-charge-detail';
import PatientProcedureChargeUpdate from './patient-procedure-charge-update';
import PatientProcedureChargeDeleteDialog from './patient-procedure-charge-delete-dialog';

const PatientProcedureChargeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedureCharge />} />
    <Route path="new" element={<PatientProcedureChargeUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedureChargeDetail />} />
      <Route path="edit" element={<PatientProcedureChargeUpdate />} />
      <Route path="delete" element={<PatientProcedureChargeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedureChargeRoutes;
